import { AtradiusCoverRequestStatus, AtradiusCoverStatus } from '@40seas/entities/atradius';
import { EnumColor } from '@40seas/frontend/common/providers';

export const atradiusStatusColorMapping = {
    [AtradiusCoverStatus.Pending]: 'default',
    [AtradiusCoverStatus.Cover]: 'success',
    [AtradiusCoverStatus.Partial]: 'success',
    [AtradiusCoverStatus.PartialExpiry]: 'warning',
    [AtradiusCoverStatus.Rejected]: 'error',
    [AtradiusCoverStatus.ReductionOfCover]: 'warning',
    [AtradiusCoverStatus.RefusalForIncrease]: 'warning',
    [AtradiusCoverStatus.WithdrawalOfLimit]: 'default',
    [AtradiusCoverStatus.Revised]: 'success',
    [AtradiusCoverStatus.Reissue]: 'success',
} as { [key in AtradiusCoverStatus]: EnumColor };

export const atradiusCoverRequestStatusColorMapping = {
    [AtradiusCoverRequestStatus.Decision]: 'success',
    [AtradiusCoverRequestStatus.ManualReview]: 'default',
};
